import { Mixin } from "@/mixins";

const set = (key) => (state, val) => {
  state[key] = val;
};

function initialState() {
  return {
    lines: [],
    total: 0,
    query: {},
    loading: false,
  };
}

const getters = {
  socialLines: (state) => state.lines,
  socialTotal: (state) => state.total,
  socialLoading: (state) => state.loading,
};

const actions = {
  fetchSocialOperators({ commit }, payload = {}) {
    commit("setLoading", true);

    const socialId = payload.socialId;

    let apiUrl = "social/data";

    if (socialId) {
      apiUrl += `?social=${socialId}`;
    }

    Mixin.methods
      .requestApiGet(apiUrl)
      .then((response) => {
        const rawItems = response?.data?.data?.data || [];

        const reformat = rawItems
          .filter((op) => op.status === "accept")
          .map((op) => {
            let label = `${op.username}`;

            if (op.max_sends && op.count_sends)
              label += ` - اعتبار ارسال باقی‌مانده: ${
                op.max_sends - op.count_sends
              }`;
            else if (op.max_sends)
              label += ` - اعتبار ارسال باقی‌مانده: ${op.max_sends}`;

            const color =
              op.status === "accept"
                ? "#2e7d32"
                : op.status === "pending"
                ? "#ef6c00"
                : "#c62828";

            const coloredText = `<span style="color: ${color};">${label.trim()}</span>`;

            return {
              value: op.username,
              text: coloredText,
              raw: op,
            };
          });

        commit("setLines", reformat);
        commit("setTotal", response?.data?.total || reformat.length);
      })
      .catch((err) => {
        console.error("خطا در بارگذاری اپراتورهای شبکه اجتماعی:", err);
      })
      .finally(() => commit("setLoading", false));
  },
};

const mutations = {
  setLines: set("lines"),
  setTotal: set("total"),
  setLoading: set("loading"),
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
